import React, { useCallback, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import Slider from 'react-slick'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
// import { FavouritesWIcon } from 'components/ui-kit/Icons/svg/index'
import {
  crash,
  // dice,
  hilo,
  mine2,
  plinko,
  coinflip,
  roulette,
  blackjack,
  keno
} from 'components/ui-kit/Icons/png/index'
import ContentHeader from 'components/ui-kit/ContentHeader/index'
import { OriginalsIcon } from 'components/ui-kit/Icons/svg/index'
import { DEFAULT_GAME_ID, ROUTE_PATHS } from 'constants/index'
import { setShowLoginPopup } from 'redux-thunk/redux/slices/gameSetting.slice'
import { setTab } from 'redux-thunk/redux/slices/lobby.slice'
import { openInfoToaster } from 'helpers/toaster.helpers'

const originalGames = [
  {
    id: DEFAULT_GAME_ID.CRASH,
    img: crash,
    path: ROUTE_PATHS.CRASH_GAME
  },
  {
    id: DEFAULT_GAME_ID.MINE,
    img: mine2,
    path: ROUTE_PATHS.MINE_GAME
  },
  {
    id: DEFAULT_GAME_ID.HILO,
    img: hilo,
    path: ROUTE_PATHS.HILO_GAME
  },
  {
    id: DEFAULT_GAME_ID.PLINKO,
    img: plinko,
    path: ROUTE_PATHS.PLINKO_GAME
  },
  // {
  //   id: '4',
  //   img: dice,
  //   path: ROUTE_PATHS.DICE_GAME
  // },
  {
    id: DEFAULT_GAME_ID.FLIP_COIN,
    img: coinflip,
    path: ROUTE_PATHS.FLIP_COIN_GAME
  },
  {
    id: DEFAULT_GAME_ID.KENO,
    img: keno,
    path: ROUTE_PATHS.KENO_GAME
  },
  {
    id: DEFAULT_GAME_ID.ROULETTE,
    img: roulette,
    path: ROUTE_PATHS.ROULETTE_GAME
  },
  {
    id: DEFAULT_GAME_ID.BLACKJACK,
    img: blackjack,
    path: ROUTE_PATHS.BLACKJACK_GAME
  }
]

const OriginalsGames = (props) => {
  const { title, gameId } = props
  const { t } = useTranslation()
  const { loginData } = useSelector(state => state.auth)
  const history = useHistory()
  const dispatch = useDispatch()

  const handleRedirectToGame = useCallback((path) => {
    if (loginData?.accessToken) {
      history.push(path)
    } else {
      dispatch(setShowLoginPopup(true))
    }
  }, [loginData])

  const homeCasinoSettings = useMemo(
    () => ({
      initialSlide: 0,
      dots: true,
      infinite: true,
      arrows: true,
      speed: 500,
      autoplay: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    }),
    []
  )

  const viewAllHandler = (e, info) => {
    if (info?.title === 'Clutch Originals') {
      dispatch(setTab('originals'))
    }
  }

  return (
    <section className='global-casino-section'>
      <ContentHeader
        title={title ? t(`${title}`) : t('clutchOriginals')}
        // subtitle={t('allGames')}
        Icon={OriginalsIcon}
        subtitleOnClickHandler={viewAllHandler}
      />
      <div className='slide-wrap p-0 m-0'>
        <Slider {...homeCasinoSettings}>
          {originalGames?.filter(game => game.id !== gameId)?.map(game => (
            <div
              key={game.id}
              className='col px-06'
            >
              <div className='theme-card-wrap'>
                <div
                  className='theme-card'
                  onClick={(e) => {
                    e.preventDefault()
                    // if (game?.id === 1 || game?.id === 2) {
                    handleRedirectToGame(game.path)
                    // } else {
                    //   openInfoToaster({ message: 'Coming Soon!' })
                    // }
                    // handleRedirectToGame(game.path)
                  }}
                >
                  <div className='casino-img-wrap'>
                    <img src={game.img} alt={game.id} />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  )
}

export default React.memo(OriginalsGames)
